<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="h-auto md:h-[80vh] rounded-2xl overflow-hidden mt-32 flex">
      <!-- Left Image -->
      <div
        class="hidden md:block md:w-1/2 bg-cover bg-center"
        style="
          background-image: url('./login.png');
        "
      ></div>

      <!-- Right Form -->
      <div
        class="flex flex-col justify-center w-full md:w-1/2 px-5 md:py-0 py-5 md:px-16 bg-white"
      >
        <h2
          class="text-4xl font-extrabold mb-8"
          [style.color]="'var(--primary)'"
        >
          Sign In
        </h2>
        <form
          (ngSubmit)="onSubmit()"
          [formGroup]="signInForm"
          class="space-y-6 max-w-md w-full"
        >
          <input
            type="email"
            placeholder="Email address"
            formControlName="email"
            name="email"
            [class]="
              signInForm.get('email')?.touched &&
              signInForm.get('email')?.invalid
                ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
            "
            required
            class="w-full px-4 py-3 rounded-xl border focus:outline-none"
          />
          <div class="relative w-full">
            <input
              [type]="hideSignInPassword ? 'password' : 'text'"
              placeholder="Password"
              formControlName="password"
              name="password"
              [class]="
                signInForm.get('password')?.touched &&
                signInForm.get('password')?.invalid
                  ? 'focus:ring-2 focus:ring-red-600 border-red-300'
                  : 'focus:ring-2 focus:ring-[var(--primary)] border-gray-300'
              "
              required
              class="w-full px-4 py-3 pr-12 rounded-xl border focus:outline-none"
            />

            <!-- FontAwesome Icon -->
            <fa-icon
              [icon]="hideSignInPassword ? faEye : faEyeSlash"
              (click)="hideSignInPassword = !hideSignInPassword"
              class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500 hover:text-[var(--primary)] transition"
            ></fa-icon>
          </div>
          <!-- Forgot password link -->
          <div class="flex justify-end">
            <a
              routerLink="/forgot-password"
              class="text-sm text-[var(--primary)] font-semibold hover:underline cursor-pointer"
            >
              Forgot Password?
            </a>
          </div>

          <button
            type="submit"
            [disabled]="signInForm.invalid || loading"
           class="w-full cursor-pointer flex items-center justify-center gap-1 py-3 rounded-xl font-semibold border transition bg-[var(--primary)] text-white border-[var(--primary)]  disabled:bg-gray-400 disabled:text-gray-200 disabled:border-gray-400 disabled:cursor-not-allowed disabled:hover:bg-gray-400 disabled:hover:text-gray-200"
          >
            @if (loading) {
              <svg
                class="animate-spin h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  class="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  stroke-width="4"
                ></circle>
                <path
                  class="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
              </svg>
              Loading...
            } @else {
              Sign In
            }
          </button>
          <button
            [disabled]="loading"
            (click)="signInWithGoogle()"
            type="button"
            class="mt-6 w-full flex cursor-pointer justify-center items-center gap-3 py-3 border border-gray-300 rounded-xl hover:bg-gray-200 transition"
          >
            <img src="./google.png" alt="Google logo" class="w-6 h-6" />
            <span class="text-gray-700 font-semibold">Sign in with Google</span>
          </button>
        </form>

        <p class="mt-6 text-gray-700">
          Don't have an account?
          <a
            routerLink="/sign-up"
            class="text-[var(--primary)] font-semibold hover:underline cursor-pointer"
            >Sign Up</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
